import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCompanies',
})
export class FilterCompaniesPipe implements PipeTransform {
  transform(companies: any[], ...filters: string[]): any[] {
    if (!companies || !filters || filters.length === 0) {
      return companies;
    }

    const filterNames = filters.filter((f) => typeof f === 'string') as string[];
    if (filterNames.length === 0) {
      return companies;
    }

    return companies.filter((company) =>
      filterNames.some((filterName) => company?.name?.toLowerCase().includes(filterName.toLowerCase()))
    );
  }
}
